import { Link } from 'react-router-dom';

export default function BrandStory() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20illustration%20of%20a%20girl%20sketching%20a%20cute%20rabbit%20on%20paper%20at%20a%20sunlit%20cafe%20table%2C%20with%20coffee%20and%20pastel%20decorations%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20dreamy%20atmosphere%2C%20artistic%20illustration%20style&width=800&height=600&seq=brand-story-01&orientation=landscape"
                alt="嫩小兔品牌故事"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <p className="text-xs md:text-sm font-label text-primary-500 tracking-widest mb-2">
              ✦ OUR STORY ✦
            </p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
              从一张纸巾开始的萌趣故事
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              2019年的一个午后，创始人小鹿在咖啡馆的纸巾上随手画下了一只软绵绵的小兔子——圆圆的脸蛋、长长垂下的耳朵、粉扑扑的腮红。她给它取名<strong>嫩小兔</strong>，希望它能传递一种软萌、温暖、治愈的力量。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              如今，<strong>嫩小兔</strong>已经成为一个拥有超过500万粉丝的萌系潮流品牌，汇聚了<strong>嫩小兔玩偶</strong>、<strong>嫩小兔周边</strong>、联名产品和限定礼盒。但不变的，是那份最初的治愈与温暖。
            </p>
            <Link
              to="/article/nenxiaotu-brand-story"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              阅读完整故事
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}